var map = {
	"./Home": [
		8008,
		8
	],
	"./Home/": [
		8008,
		8
	],
	"./Home/index": [
		8008,
		8
	],
	"./Home/index.tsx": [
		8008,
		8
	],
	"./Privacy": [
		2772,
		772
	],
	"./Privacy/": [
		2772,
		772
	],
	"./Privacy/index": [
		2772,
		772
	],
	"./Privacy/index.tsx": [
		2772,
		772
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 717;
module.exports = webpackAsyncContext;